/** @jsxImportSource @emotion/react */
import { faCaretDown, faCaretUp } from "@fortawesome/pro-regular-svg-icons";
import { Link, useParams } from "react-router-dom";
import { LAYER_TAB_CATEGORIES } from "../../../../actions/Layers/constants";
import useConfig from "../../../../actions/Tenants/config/configHook";
import { CONFIG_TYPES } from "../../../../actions/Tenants/config/constants";
import { getFilledArrayOrDefault } from "../../../../utils";
import { Button } from "../../../Helper/Button";

// Preview display for configs
const preview = (item) => (
    <div className="mb-0 fw-bold">
        {item.config?.text}

        {item.type === CONFIG_TYPES.STAGE ? (
            <>
                [{getFilledArrayOrDefault(item.config?.tab_categories, [LAYER_TAB_CATEGORIES.OPERATION]).join(" | ")} <b>::</b>{" "}
                {item.value}]
            </>
        ) : (
            <>[{item.value}]</>
        )}
    </div>
);

export const ItemContent = ({
    item,
    isFirstItem,
    isLastItem,
    onDeactivate,
    onActivate,
    onUpdatePosition,
    index,
    showControls = true,
}: {
  item: any;
  isFirstItem: boolean;
  isLastItem: boolean;
  onDeactivate?: (item: any) => void;
  onActivate?: (item: any) => void;
  index: number;
  onUpdatePosition?: (from, to) => void;
  showControls?: boolean;
}) => {
    const config = useConfig();
    const params = useParams();
    const { tenant_id } = params;

    const positionUp = () => {
        // * cannot move first item up, duh
        if (index === 0) return;

        onUpdatePosition?.(index, index - 1);
    };

    const positionDown = () => {
        if (index + 1 === config.configs.length) return;

        onUpdatePosition?.(index, index + 1);
    };

    return (
        <div className="d-flex align-items-center">
            <span className={showControls ? undefined : "opacity-50"}>{preview(item)}</span>

            {showControls && <>
                <Button
                    size="sm"
                    color="light"
                    className="ms-auto my-1"
                    disabled={isFirstItem}
                    onClick={positionUp}
                    icon={faCaretUp}
                />

                <Button
                    size="sm"
                    color="light"
                    className="ms-2 my-1"
                    disabled={isLastItem}
                    onClick={positionDown}
                    icon={faCaretDown}
                />

                {onDeactivate && <Button color="danger" className="ms-2 my-1" outline size="sm" onClick={() => onDeactivate(item)}>
                    Deactivate
                </Button>}

                <Link className="ms-2 my-1 btn btn-light btn-sm" to={`/tenants/${tenant_id}/config/${item.id}`}>
                    Edit
                </Link>
            </>}

            {!showControls && <>
                <Button color="success" className="ms-auto ms-2 my-1" outline size="sm" onClick={() => onActivate?.(item)}>
                    Activate
                </Button>

                <Link className="ms-2 my-1 btn btn-light btn-sm" to={`/tenants/${tenant_id}/config/${item.id}`}>
                    Edit
                </Link>
            </>}
        </div>
    );
};
